import React, { FunctionComponent, useState, useRef, ReactElement } from 'react';
import { ExpandingArea, ExpandingAreaProps } from './index';
import { FormattedMessage } from 'react-intl';
import scrollIntoView from 'scroll-into-view';
import { ReadMoreButton } from './ReadMoreButton';

import styles from './ExpandingAreaWithReadMore.scss';

const READ_MORE = 'readMore';
const READ_LESS = 'readLess';
type ExpandingAreaWithReadMoreProps = Omit<ExpandingAreaProps, 'expanded'> & {
    readMore?: ReactElement;
    readLess?: ReactElement;
    buttonClass?: string;
    onReadMoreClick?: ({ type }: { type: typeof READ_MORE | typeof READ_LESS }) => void;
};

const readMoreMessage = (
    <FormattedMessage id="expandingArea.continueReading" defaultMessage="Continue reading" />
);
const readLessMessage = <FormattedMessage id="expandingArea.readLess" defaultMessage="Read less" />;

export const ExpandingAreaWithReadMore: FunctionComponent<ExpandingAreaWithReadMoreProps> = ({
    readMore = readMoreMessage,
    readLess = readLessMessage,
    wrapperClass,
    buttonClass,
    onReadMoreClick,
    ...props
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isContentExpandable, setIsContentExpandable] = useState(false);
    const contentRef = useRef(null);

    return (
        <div className={wrapperClass} ref={contentRef}>
            <ExpandingArea
                {...props}
                wrapperClass={styles.expandingAreaWrapper}
                expanded={isExpanded}
                setIsContentExpandable={setIsContentExpandable}
            />

            {isContentExpandable && (
                <ReadMoreButton
                    isExpanded={isExpanded}
                    className={buttonClass}
                    onClick={() => {
                        if (onReadMoreClick) {
                            onReadMoreClick({ type: isExpanded ? READ_LESS : READ_MORE });
                        }
                        if (isExpanded && contentRef && contentRef.current) {
                            scrollIntoView(contentRef.current, { time: 200 });
                        }
                        setIsExpanded(!isExpanded);
                    }}
                    readLessMessage={readLess}
                    readMoreMessage={readMore}
                />
            )}
        </div>
    );
};
